import { render, staticRenderFns } from "./listUserTwo.vue?vue&type=template&id=165a4590&scoped=true"
import script from "./listUserTwo.vue?vue&type=script&lang=js"
export * from "./listUserTwo.vue?vue&type=script&lang=js"
import style0 from "./listUserTwo.vue?vue&type=style&index=0&id=165a4590&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165a4590",
  null
  
)

export default component.exports